export enum messageType {
  ERROR = "error",
  INFO = "info",
}
export interface IMessage {
  type: messageType;
  value: string;
}